/**
 * @Description: test模块路由
 * @Date: 2022-11-26
 * @LastEditTime: 2022-11-26
 */
import { RoutesTypeNew } from '@/types/routes'
import { UserSwitchOutlined } from '@ant-design/icons'

const product: RoutesTypeNew = [
  {
    path: 'product',
    component: () => import(/* webpackChunkName: "product-index" */ '@/views/product/index'),
    meta: {
      title: '产品清单',
      icon: <UserSwitchOutlined />,
      noLogin: true,
      dynamicTitleType: 'businessUnit',
    },
  },
  {
    path: 'product/detail/:id',
    component: () => import(/* webpackChunkName: "thermometer" */ '@/views/product/detail'),
    meta: {
      title: '产品详情',
      noLogin: true,
      dynamicTitleType: 'product',
    },
  },
]

export default product
